// extracted by mini-css-extract-plugin
export var arrows = "_2d-5";
export var decrementer = "_2d-9";
export var disabled = "_2d-3";
export var error = "_2d-1";
export var hiddenText = "_2d-a";
export var incrementer = "_2d-8";
export var input = "_2d-7";
export var inputWrapper = "_2d-0";
export var leadingIcon = "_2d-b";
export var readonly = "_2d-2";
export var regular = "_2d-6";
export var small = "_2d-4";